(() => {
  const revealItems = document.querySelectorAll('[data-mirthloom-reveal]');
  if ('IntersectionObserver' in window && revealItems.length) {
    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  /* Keep the sticky selector aligned with Shopify's native variant picker. */
  const sticky = document.querySelector('[data-mirthloom-sticky-bar]');
  const productForm = document.querySelector('product-form form[action*="/cart/add"]');
  if (sticky && productForm) {
    const stickyVariant = sticky.querySelector('[data-sticky-variant]');
    const sync = () => {
      if (!stickyVariant) return;
      const nativeVariant = productForm.querySelector('input[name="id"]');
      if (!nativeVariant) return;
      const option = Array.from(stickyVariant.options || []).find((item) => item.value === nativeVariant.value);
      if (option) stickyVariant.value = option.value;
    };
    productForm.addEventListener('change', sync);
    document.addEventListener('variant:change', sync);
    sync();
  }

  /* Judge.me can return a broken thumbnail URL while its full-size review
     photo link remains valid. Repair only failed review thumbnails. */
  const repairJudgeMePhotos = () => {
    document.querySelectorAll('#judgeme_product_reviews .jdgm-rev__pic-link').forEach((link) => {
      const image = link.querySelector('.jdgm-rev__pic-img, img');
      const fullImageUrl = link.getAttribute('href');
      const thumbnailUrl = image?.getAttribute('src') || image?.dataset.src;

      if (!image || !fullImageUrl || image.dataset.mirthloomPhotoReady === 'true') return;
      if (!/^(https?:)?\/\//i.test(fullImageUrl)) return;

      image.dataset.mirthloomPhotoReady = 'true';

      const removeLoader = () => link.classList.remove('jdgm--loading');
      const useFullImage = () => {
        if (image.dataset.mirthloomPhotoFallback === 'true') {
          removeLoader();
          return;
        }
        image.dataset.mirthloomPhotoFallback = 'true';
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = fullImageUrl;
      };

      image.addEventListener('load', removeLoader);
      image.addEventListener('error', useFullImage);

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      if (thumbnailUrl) image.src = thumbnailUrl;
      else useFullImage();

      if (image.complete && image.naturalWidth > 0) removeLoader();
      else if (image.complete && image.naturalWidth === 0) useFullImage();
    });
  };

  repairJudgeMePhotos();

  const judgeMePhotoObserver = new MutationObserver(repairJudgeMePhotos);
  judgeMePhotoObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
